<template>

    <div>

        <div class="row mb-4">

            <div class="col-24 col-md-6 mb-4 mb-md-0">
                <input type="text"
                       class="form-control new-list-group-field"
                       placeholder="Sök massör eller mottagning"
                       v-model="settings.query.text"
                >
            </div>

            <div class="col-12 col-md-4 mb-4 mb-md-0">
                <datepicker-new
                    input-class="form-control new-list-group-field"
                    :clear-button="true"
                    clear-button-icon="fa fa-times"
                    placeholder="Från datum"
                    :language="former.datepicker.locale"
                    :use-utc="true"
                    :monday-first="true"
                    :format="formerDateFormat"
                    v-model="settings.query.treatment_at_from"
                />
            </div>

            <div class="col-12 col-md-4 mb-4 mb-md-0">
                <datepicker-new
                    input-class="form-control new-list-group-field"
                    :clear-button="true"
                    clear-button-icon="fa fa-times"
                    placeholder="Till datum"
                    :language="former.datepicker.locale"
                    :use-utc="true"
                    :monday-first="true"
                    :format="formerDateFormat"
                    v-model="settings.query.treatment_at_to"
                />
            </div>

            <div class="col-12 col-md-7 mb-4 mb-md-0 d-flex">
                <select class="form-select new-list-group-field" v-model="settings.query.type">
                    <option :value="null">På mottagning & arbetsplatsen</option>
                    <option value="internal">På mottagning</option>
                    <option value="external">På arbetsplatsen</option>
                </select>
            </div>

            <div class="col-24 col-md-3 d-flex justify-content-end">
                <button class="btn btn-primary btn-sm float-end" @click="openExportModal()">Exportera
                    <div class="tooltip-label">Ladda ner en excel med alla filtrerade behandlingar.</div>
                </button>
            </div>

        </div>

        <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
            <div slot="item-row" slot-scope="props">
                <treatments-list-item-row
                    :treatment="props.item"
                    displayFrom="employee"
                    @refresh="refresh()"
                />
            </div>
        </list>
    </div>

</template>

<script>
import lister from '../../../../shared/mixins/lister'
import former from '../../../../shared/mixins/former'

import TreatmentsListItemRow from '../companies/treatments-list-item-row'

export default {
    components: {
        TreatmentsListItemRow
    },

    mixins: [
        lister,
        former
    ],

    props: {
        employee: {
            required: true
        }
    },

    data () {
        return {
            settings: {
                url: '/employees/' + this.employee.id + '/treatments/list',
                query: {
                    text: '',
                    treatment_at_from: null,
                    treatment_at_to: null,
                    type: null
                },
                columns: [
                    { column: 'treatment_at', name: 'Beh.datum', class: 'col-3', sortable: true, default: true },
                    { column: 'location', name: 'Beh. plats', class: 'col-4', sortable: false },
                    { column: 'clinic_name', name: 'Massör', class: 'col-3', sortable: false },
                    { column: 'duration', name: 'Längd', class: 'col-2', sortable: true },
                    { column: 'part_payment', name: 'Delbetalning', class: 'col-3', sortable: false },
                    { column: 'punched_by', name: 'Registrerad av', class: 'col-3', sortable: false },
                    { column: 'created_at', name: 'Reg.datum', class: 'col-2', sortable: true },
                    { column: 'buttons', name: '', class: 'col-1', sortable: false }
                ],
                bulk_actions: [],
                export_fields: [
                    { column: 'treatment_at', name: 'Behandlingsdatum' },
                    { column: 'employee.name', name: 'Anställd' },
                    { column: 'employeeWorkplace.title', name: 'Arbetsplats' },
                    { column: 'location', name: 'Behandlingsplats' },
                    { column: 'is_internal', name: 'På mottagning' },
                    { column: 'is_external', name: 'På arbetsplatsen' },
                    { column: 'clinic.name_person', name: 'Massör' },
                    { column: 'contract.subscription.duration.name', name: 'Längd' },
                    { column: 'part_payment_text', name: 'Delbetalning' },
                    { column: 'punched_by_text', name: 'Registrerad av' },
                    { column: 'created_at', name: 'Registreringsdatum' }
                ]
            }
        }
    }
}
</script>
